import {Model} from 'backbone';
import formModel from 'formModel'
import undoService from 'UndoService'
import pageSyncService from 'PageSyncService';
import textConstants from 'TextConstants';
import eventBus from 'EventBus';
import listService from 'ListService';
import constants from 'Constants';

class PageModel extends Model {

    initialize() {

		formModel.set({
			currentPage: this.id
		});

        this.initDevice = {
            isHidden: this.get('isHidden')
        };

        this.initDeviceTablet = {
            isHidden: this.get('isHidden')
        };

        this.initDevicePhone = {
            isHidden: this.get('isHidden')
        };

        this.set({
            deviceDesktop: this.initDevice,
            deviceTablet: this.initDeviceTablet,
            devicePhone: this.initDevicePhone,
            objects: [],
            objectCount: 0,
            behaviors: [],
            behaviorCount: 0
        });

        this.on('change:isHidden', () => {
            this.get(formModel.get('currentDevice')).isHidden = this.get('isHidden');
        });

        formModel.on('change:currentDevice', () => {
            this.set( this.attributes[this.attributes.currentDevice] , {silent: true} );
        });

        this.lastState = this.toJSON();

        this.set('undoAction', false, {silent: true});

        this.isInit = true;

        this.on('change', (ev, attrs) => {
            const undoRedoCommonFn = (aState, mapReviver) => {
                // we load the saved version
                this.set(JSON.parse(aState, mapReviver), {silent: true});

                // we want to ignore what was set for this, this is important to not register another undo
                this.set('undoAction', true, {silent: true});

                // Setting form values manually on undo/redo of the page and updating its respective MainSizeView.
                //currentForm should keep the values, those will be set to the pages during saving.
                //listService.currentForm.model.set('formHeight', this.get('height'), {silent: true});
                //listService.currentForm.model.set('formWidth', this.get('width'), {silent: true});
                eventBus.trigger('formPropertiesChanged');
                pageSyncService.renderCurrentPageView();

                // Refresh rendered page title in this page's thumbnail (whether it changed or not)
                eventBus.trigger(constants.EV_RENAME_PAGE, this.get('id'), this.get('pageTitle'));

                // Refresh the breadcrumb
                const breadCrumbType = this.get('factoryKey') === 'page_instance' ? 'PAGE' : 'OBJECT';
                eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, breadCrumbType, this.get('id'));

                // we trigger change because all views listening need to update
                this.trigger('change');
            };

            if(this.get('undoAction')){
                this.set('undoAction', false, {silent: true});
                this.lastState = this.toJSON();

            } else {

                if(listService.mainKind !== constants.KIND_MOBILE && !attrs.unsetParsedItem){
                    const
                        lastState = this.lastState,
                        newState = JSON.stringify(this);

                    undoService.add({
                        undo: () => {
                            undoRedoCommonFn(lastState, this.mapReviver);
                        },
                        redo: () => {
                            undoRedoCommonFn(newState, this.mapReviver);
                        }
                    }, textConstants.UNDO_PAGE_CHANGE);

                    this.lastState = this.toJSON();
                }
            }

        });
    }

    set lastState(state){
        this._lastState = JSON.stringify(state);
    }

    get lastState() {
        return this._lastState;
    }

    get mapReviver(){
        return (key, value) => {
            let serializedValue = value;
            if(key === 'mandatories' || key === 'state' ){
                serializedValue = new Map(value);
            }
            return serializedValue;
        };
    }


    defaults() {
        return {};
    }

}

export default PageModel;

